import React, { useState } from "react";
import { Button, Form, Input, InputNumber, message } from "antd";
import orderService from "../../services/OrderLists";
import { useParams } from "react-router-dom";

const { TextArea } = Input;

const RaiseWordRequest = ({ handleModalClose, fetchOrderDetails }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { orderKey } = useParams();

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const payload = {
                task: orderKey,
                requested_word_count: values.requested_word_count,
                justification: values.justification,
            };
            const response = await orderService.createExtraWordCountRequest(payload);
            if (response.success) {
                message.success("Extra word count request raised successfully!");
                fetchOrderDetails();
                handleModalClose();
            } else {
                message.error("Failed to raise request.");
            }
        } catch (error) {
            console.error("Error raising word count request:", error);
            message.error("An error occurred.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: "0 10px 10px 10px" }}>
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                style={{ display: "flex", flexDirection: "column" }}
            >
                <Form.Item
                    name="requested_word_count"
                    label="Requested Word Count"
                    rules={[{ required: true, message: "Please enter word count" }]}
                >
                    <InputNumber style={{ width: "100%" }} placeholder="Enter word count" />
                </Form.Item>

                <Form.Item
                    name="justification"
                    label="Remarks"
                    rules={[{ required: true, message: "Please enter remarks" }]}
                >
                    <TextArea rows={4} placeholder="Enter your justification/remarks" />
                </Form.Item>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <Button onClick={handleModalClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Submit Request
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default RaiseWordRequest;